import React from "react";
import { NavLink } from "react-router-dom";
import Container from "../../../../modules/commons/Container";
import FlexView from "react-flexview";

const menuItems = [
  {
    label: "Laporan Harian Unit By Mekanik & SA",
    link: "/dashboard/level-mekanik-sa/laporan-harian-unit-monitoring",
    icon: "fa fa-tv",
    id: "btn_navigate_dashboard_laporan_harian_unit_monitoring",
  },
  {
    label: "Laporan Harian Part By Mekanik & SA",
    link: "/dashboard/level-mekanik-sa/laporan-harian-part-monitoring",
    icon: "fa fa-tv",
    id: "btn_navigate_dashboard_laporan_harian_part_monitoring",
  }
];

const DashboardLevelMekanikSA = () => {
  return (
    <React.Fragment>
      <Container>
        <FlexView style={{ gap: "20px" }}>
          {menuItems.map((item) => (
            <NavLink key={item.id} id={item.id} to={item.link}>
              <FlexView
                column
                vAlignContent="center"
                hAlignContent="center"
                className="background-red txt-site txt-white"
                style={{
                  width: 235,
                  height: 235,
                  border: "2px solid #000",
                  borderRadius: 5,
                  gap: "10px",
                }}
              >
                <i className={`${item.icon} fa-lg`}></i>
                <div className="text-center" style={{ textAlign: 'center', maxWidth:"200px"}}>{item.label}</div>
              </FlexView>
            </NavLink>
          ))}
        </FlexView>
      </Container>
    </React.Fragment>
  );
};

export default DashboardLevelMekanikSA;
